/* eslint-disable no-return-assign */
import React, { useMemo, useState, useEffect } from "react";
import { Box, Radio } from "@mui/material";
import DoughnutChart from "./components/DoughnutChart";
import BarChart from "./components/BarChart";
import Legend from "./components/Legend";

function KpiBreakdown({ graphData, display = "doughnut" }) {
  const { labels, data, colors } = graphData;
  const [dataStructure, setDataStructure] = useState({
    labels: [],
    data: [],
    colors: [],
    percentages: [],
  });
  const [graphDisplay, setGraphDisplay] = useState(display);
  const displayLegend = true;

  const sortData = () => {
    const total = data.length && data.reduce((a, v) => a + v);
    const dataIndex = {};
    for (let i = 0; i < data.length; i += 1) {
      dataIndex[i] = data[i];
    }
    const dataIndexArray = Object.entries(dataIndex);
    dataIndexArray.sort((a, b) => b[1] - a[1]);
    const dataOrder = dataIndexArray.map((x) => parseInt(x[0], 10));

    const sortedDataStructure = { labels: [], data: [], colors: [], percentages: [] };
    for (let i = 0; i < data.length; i += 1) {
      sortedDataStructure.labels.push(labels[dataOrder[i]]);
      sortedDataStructure.data.push(data[dataOrder[i]]);
      sortedDataStructure.colors.push(colors[dataOrder[i]]);
      sortedDataStructure.percentages.push(Math.round((data[dataOrder[i]] / total) * 100));
    }
    setDataStructure(sortedDataStructure);
  };

  useEffect(() => {
    sortData();
  }, [graphData]);

  const handleGraphChange = (event) => {
    setGraphDisplay(event.target.value);
  };

  return useMemo(
    () => (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {graphDisplay === "doughnut" ? (
          <Box
            sx={{
              flexGrow: 1,
              position: "relative",
              width: "95%",
              maxWidth: "300px",
            }}
          >
            <DoughnutChart dataStructure={dataStructure} label="KPIs" />
          </Box>
        ) : (
          <Box
            sx={{
              flexGrow: 1,
              position: "relative",
              width: "100%",
            }}
          >
            <BarChart dataStructure={dataStructure} />
          </Box>
        )}
        {displayLegend && <Legend dataStructure={dataStructure} />}
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Radio
            checked={graphDisplay === "doughnut"}
            onChange={handleGraphChange}
            value="doughnut"
            name="radio-buttons"
            inputProps={{ "aria-label": "Achieved Points Breakdown" }}
          />
          <Radio
            checked={graphDisplay === "bar"}
            onChange={handleGraphChange}
            value="bar"
            name="radio-buttons"
            inputProps={{ "aria-label": "Kpi Breakdown" }}
          />
        </Box>
      </Box>
    ),
    [dataStructure, graphDisplay]
  );
}

export default KpiBreakdown;
